import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouteReuseStrategy } from "@angular/router";
import { AgGridModule } from "ag-grid-angular";
import "ag-grid-enterprise";
import { LicenseManager } from "ag-grid-enterprise";
import { CurrencyMaskInputMode, NgxCurrencyModule } from "ngx-currency";
import { provideEnvironmentNgxMask } from "ngx-mask";
import { NgxSpinnerModule } from "ngx-spinner";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { GridService } from "./common/core/client-side-list-base/grid.service";
import { LoggedInUserGuard } from "./common/guards/loggedin-user.guard";
import { CanDeactivateGuard } from "./common/guards/unsaved-changes-guard";
import { AuthInterceptor } from "./common/interceptors/auth.interceptor";
import { IdleTimerService } from "./common/services/idle-timer.service";
import { HeaderComponent } from "./features/header/header.component";
import { CustomRouteReuseStrategy } from "./router-strategy";
import { SidenavComponent } from "./features/sidenav/sidenav.component";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";
import { DateRangePickerModule } from "./common/components/core/date-range-picker/date-range-picker.module";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { TraceIdInterceptor } from "./common/interceptors/traceId.interceptor";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { environment } from "environment";
import { NgxMatomoTrackerModule } from "ngx-matomo-client";
import { CertificationsComponent } from './features/patients/documentation/certifications/certifications.component';
LicenseManager.setLicenseKey(
  "CompanyName=Z.Pax LLC,LicensedApplication=Z.Pax LLC,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,AssetReference=AG-038529,SupportServicesEnd=20_February_2024_[v2]_MTcwODM4NzIwMDAwMA==a82e61f67a7974877b46fff63472e8e8"
);
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    DateRangePickerModule,
    BrowserAnimationsModule,
    AgGridModule,
    HttpClientModule,
    MatSnackBarModule,
    MatDatepickerModule,
    MatNativeDateModule,
    HeaderComponent,
    NgxCurrencyModule.forRoot({
      align: "right",
      allowNegative: false,
      allowZero: true,
      decimal: ".",
      precision: 2,
      prefix: "",
      suffix: "",
      thousands: ",",
      nullable: true,
      min: null,
      max: null,
      inputMode: CurrencyMaskInputMode.FINANCIAL,
    } as any),
    MatDialogModule,
    NgxSpinnerModule.forRoot({ type: "ball-clip-rotate-multiple" }),
    SidenavComponent,
    DragDropModule,
    ...(environment.enableMatomo ? [
      NgxMatomoTrackerModule.forRoot({
        siteId: environment.matomo.siteId,
        trackerUrl: environment.matomo.trackerUrl
      })
    ] : []),
  ],
  providers: [
    provideEnvironmentNgxMask(),
    LoggedInUserGuard,
    { provide: HTTP_INTERCEPTORS, useClass: TraceIdInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    CanDeactivateGuard,
    GridService,
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
    IdleTimerService,
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { subscriptSizing: "dynamic" },
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {}
